import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@beego/ngx-filter';
import { FilterModule } from '@beego/ngx-filter';
import * as i2 from '@beego/ngx-autosize-input';
import { AutoSizeInputModule } from '@beego/ngx-autosize-input';

class InputFilterComponent {
    name;
    placeholder;
    input;
    type = 'text';
    filter = new EventEmitter();
    valueIsValid = true;
    id;
    ngOnInit() {
        this.id = `input-filter-${Math.random().toString()}`;
    }
    ngAfterViewInit() {
        if (this.input) {
            document.getElementById(this.id).value = this.input;
        }
    }
    onValueChange(_value) {
        if (_value.length === 0) {
            this.filterData('');
            return;
        }
    }
    filterData(_value) {
        this.filter.emit(_value);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: InputFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.7", type: InputFilterComponent, selector: "input-filter-component", inputs: { name: "name", placeholder: "placeholder", input: "input", type: "type" }, outputs: { filter: "filter" }, ngImport: i0, template: "<filter-component [name]=\"name\">\n\t<ng-container filter-content>\n\t\t\n\t\t<input \n\t\t\t[id]=\"id\" \n\t\t\tautocomplete=\"no-auto\" \n\t\t\tautoSizeInput\n            [extraWidth]=\"10\"\n            [placeholder]=\"placeholder ?? ''\" \n\t\t\t(input)=\"onValueChange($any($event.target).value)\" \n\t\t\t(keyup.enter)=\"filterData($any($event.target).value)\" \n\t\t\t[type]=\"type\"\n\t\t/>\n\t\t\n\t</ng-container>\n</filter-component>\n\n", styles: ["input{background-color:#f1f1f1;border:1px solid #E0E0E0;padding:6px 10px;border-radius:10px;font-size:14px;color:#000;width:100%;margin:5px -10px 5px 10px}input:focus{outline:none}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}::placeholder{font-weight:400}:-ms-input-placeholder{font-weight:400}::-webkit-input-placeholder{font-weight:400}\n"], dependencies: [{ kind: "component", type: i1.DataFilterComponent, selector: "filter-component", inputs: ["name"] }, { kind: "directive", type: i2.AutoSizeInputDirective, selector: "[autoSizeInput]", inputs: ["extraWidth", "includeBorders", "includePadding", "includePlaceholder", "maxWidth", "minWidth", "setParentWidth", "usePlaceHolderWhenEmpty", "useValueProperty"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: InputFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'input-filter-component', template: "<filter-component [name]=\"name\">\n\t<ng-container filter-content>\n\t\t\n\t\t<input \n\t\t\t[id]=\"id\" \n\t\t\tautocomplete=\"no-auto\" \n\t\t\tautoSizeInput\n            [extraWidth]=\"10\"\n            [placeholder]=\"placeholder ?? ''\" \n\t\t\t(input)=\"onValueChange($any($event.target).value)\" \n\t\t\t(keyup.enter)=\"filterData($any($event.target).value)\" \n\t\t\t[type]=\"type\"\n\t\t/>\n\t\t\n\t</ng-container>\n</filter-component>\n\n", styles: ["input{background-color:#f1f1f1;border:1px solid #E0E0E0;padding:6px 10px;border-radius:10px;font-size:14px;color:#000;width:100%;margin:5px -10px 5px 10px}input:focus{outline:none}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}::placeholder{font-weight:400}:-ms-input-placeholder{font-weight:400}::-webkit-input-placeholder{font-weight:400}\n"] }]
        }], propDecorators: { name: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], input: [{
                type: Input
            }], type: [{
                type: Input
            }], filter: [{
                type: Output
            }] } });

class InputFilterModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: InputFilterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.7", ngImport: i0, type: InputFilterModule, declarations: [InputFilterComponent], imports: [FilterModule, AutoSizeInputModule], exports: [InputFilterComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: InputFilterModule, imports: [FilterModule, AutoSizeInputModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: InputFilterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [InputFilterComponent],
                    imports: [FilterModule, AutoSizeInputModule],
                    exports: [InputFilterComponent],
                }]
        }] });

/*
 * Public API Surface of ngx-input-filter
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InputFilterComponent, InputFilterModule };
